import { Injectable } from '@angular/core'
import {
	Resolve,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router'
import { Observable } from 'rxjs'
import {
	IHandlerOperationAndMonitoring
} from '../../../models/HandlerOperation'
import { HandlerOperationService } from '../../../services/handler.operation.service'

@Injectable({ providedIn: 'root' })
export class ManagementConfigurationResolver implements Resolve<Observable<IHandlerOperationAndMonitoring>> {
	constructor(
		private operationService: HandlerOperationService
	) {}

	public resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<IHandlerOperationAndMonitoring> {
		const companyId: string = localStorage.getItem('companyId')

		return this.operationService.getMonitoringManagementConfiguration(companyId)
	}
}
